import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import { ServicePackageRevisionFragmentFragmentDoc } from './servicePackageRevision.generated';
export type ServicePackageFragmentFragment = { __typename?: 'ServicePackage', id: string, package_type: Types.ServicePackageType, currency: string, created_at: string, revisions: Array<{ __typename?: 'ServicePackageRevision', id: string, revision_number: number, min_contract_term_months: number, monthly_service_fee_in_cents: number, onboarding_fee_in_cents: number, ops_order_price_in_cents: number, note?: string | null, created_at: string, created_by?: string | null, allowances: Array<{ __typename?: 'ServicePackageAssetAllowance', id: string, monthly_quantity: number, item: { __typename?: 'ItemType', id: number, name: string } }>, free_checkouts: Array<{ __typename?: 'ServicePackageFreeCheckout', id: string, segment: Types.ContainerTypeSegment, amount: number }> }> };

export const ServicePackageFragmentFragmentDoc = gql`
    fragment ServicePackageFragment on ServicePackage {
  id
  package_type
  currency
  created_at
  revisions {
    ...ServicePackageRevisionFragment
  }
}
    ${ServicePackageRevisionFragmentFragmentDoc}`;